export default __webpack_public_path__ + "static/media/249.6748e4c8.png";